import { AxiosError } from 'axios';
import { createMutation } from 'react-query-kit';

import { ErrorResponse, privateApi } from 'api';
import { invalidateQueryKeys } from 'api/hooks/middlewares';

export interface SendOnboardingParams {
  userId: string;
}

async function sendOnboarding({ userId }: SendOnboardingParams): Promise<void> {
  await privateApi.post('/onboarding/send', {
    userId,
  });
}

const useSendOnboarding = createMutation<void, SendOnboardingParams, AxiosError<ErrorResponse>>({
  mutationFn: async (variables: SendOnboardingParams) => sendOnboarding(variables),
  use: [invalidateQueryKeys([{ queryKey: ['student_profile'] }])],
});

export { sendOnboarding, useSendOnboarding };
